module.exports = __webpack_public_path__ + "static/media/R_C.1853217b.png";